import { Labels } from '../../shared-components/global/labels';

Labels.set('ui-dropdown', 'openLang', 'Atidaryti kalbos pasirinkimą');
Labels.set('ui-dropdown', 'countryCode', 'Šalies kodas');
Labels.set('ui-dropdown', 'listboxName', 'Galimi pasirinkimai');

Labels.set('ui-dropdown', 'eng', 'Anglų');
Labels.set('ui-dropdown', 'lit', 'Lietuvių');
Labels.set('ui-dropdown', 'rus', 'Rusų');
